import ProductsPage from './ProductsPage';
export default ProductsPage;
